import React, { useEffect, useState } from 'react';
import { getSettings } from './apiUtils'; // Assuming you placed the utility function in a separate file
import { getBaseUrl } from "../utils";
import Navbar from "./Navbar";
import Footer from "./Footer";

const AboutUs = () => {
  const [aboutUs, setAboutUs] = useState('');
  const baseUrl = getBaseUrl(); // Replace with your actual base URL
  const token = localStorage.getItem('userToken'); // Assuming the token is saved in local storage

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchSettings = async () => {
      const data = await getSettings(baseUrl, token);
      if (data) {
        setAboutUs(data.about_us); // Setting the fetched About Us content
      }
    };
    fetchSettings();
  }, [baseUrl, token]);

  return (
    <div className="bg-gray-100 min-h-screen mt-20">
      <Navbar />
      <div className='container-xxl'>
        <div className='row'>
          <div className='col-12'>
            <div className="">
              <h2 className="Header__text font-bold text-center pt-12">About Us</h2>
              <div
                className="terms-conditions-content"
                dangerouslySetInnerHTML={{ __html: aboutUs }}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
